<template>
  <Listbox v-model="localSelectedDashboard">
    <div class="relative w-72">
      <ListboxButton
        class="relative w-full cursor-default rounded-lg border py-1.5 pr-10 pl-3 text-left focus:outline-none sm:text-sm"
      >
        <span class="block truncate">
          {{ localSelectedDashboard?.name[$i18n.locale] }}</span
        >
        <div
          class="pointer-events-none absolute inset-y-0 right-3 flex items-center"
        >
          <FontAwesomeIcon :icon="['fal', 'chevron-down']" />
        </div>
      </ListboxButton>

      <transition
        leave-active-class="transition duration-100 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <ListboxOptions
          class="absolute z-100 max-h-60 w-full overflow-auto rounded-md border bg-white py-1 text-base shadow-lg focus:outline-none sm:text-sm dark:border-slate-500 dark:bg-slate-700 dark:shadow-2xl"
        >
          <ListboxOption
            v-for="dashboard in dashboardList"
            v-slot="{ active, selected }"
            :key="dashboard.id"
            :value="dashboard"
            as="template"
          >
            <li
              :class="[
                active
                  ? 'bg-primary-300 text-contrast-primary dark:bg-slate-600 dark:text-white'
                  : 'text-gray-900 dark:text-white',
                'relative cursor-default p-4 py-2 select-none'
              ]"
            >
              <span class="flex w-full flex-row items-center gap-3 truncate">
                <FontAwesomeIcon :icon="['fal', getIcon(dashboard.type)]" />
                <span
                  class="flex-1 truncate"
                  :class="[
                    selected ? 'font-medium' : 'font-normal',
                    capitalize ? 'capitalize-first' : ''
                  ]"
                >
                  {{ dashboard.name[$i18n.locale] }}
                </span>
              </span>

              <span
                v-if="selected"
                class="absolute inset-y-0 right-0 flex items-center pr-3"
              >
                <FontAwesomeIcon :icon="['fas', 'check']" />
              </span>
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>
<script>
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions
} from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import DashboardTypes from '@/assets/enums/dashboard/DashboardTypes'

export default {
  name: 'DashboardTabsAsSelect',
  components: {
    FontAwesomeIcon,
    ListboxOption,
    ListboxOptions,
    ListboxButton,
    Listbox
  },
  props: {
    dashboardList: {
      type: Array,
      required: true
    },
    selectedDashboard: {
      type: Object,
      required: true
    },
    capitalize: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ['update:selectedDashboard'],
  computed: {
    localSelectedDashboard: {
      get() {
        return this.dashboardList.find((dashboard) => dashboard.id == this.$route.params.id) ?? this.selectedDashboard
      },
      set(value) {
        if (value) {
          this.$router.push({
            name: this.$route.meta.route_name,
            params: { id: value?.id }
          })
        }
      }
    }
  },
  methods: {
    getIcon(type) {
      switch (type) {
        case DashboardTypes.AGENDA:
          return 'calendar-day'
        case DashboardTypes.STATISTICS:
          return 'chart-bar'
        case DashboardTypes.INVOICE:
        case DashboardTypes.PURCHASE_ORDER:
        case DashboardTypes.QUOTE:
        case DashboardTypes.CREDIT_NOTE:
          return 'euro-sign'
        case DashboardTypes.DASHBOARD:
          return 'table'
        default:
          return 'house'
      }
    }
  }
}
</script>
